/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindOrganizationUsersQueryResponse } from "../types/FindOrganizationUsers.ts"

export const findOrganizationUsersQueryKey = () =>
  [{ url: "/v1/client-user/find-organization-users" }] as const

export type FindOrganizationUsersQueryKey = ReturnType<
  typeof findOrganizationUsersQueryKey
>

/**
 * @summary Find organization users
 * {@link /v1/client-user/find-organization-users}
 */
export async function findOrganizationUsers(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindOrganizationUsersQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-user/find-organization-users`,
    ...requestConfig,
  })
  return res
}

export function findOrganizationUsersQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findOrganizationUsersQueryKey()
  return queryOptions<
    ResponseConfig<FindOrganizationUsersQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindOrganizationUsersQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findOrganizationUsers({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find organization users
 * {@link /v1/client-user/find-organization-users}
 */
export function useFindOrganizationUsers<
  TData = ResponseConfig<FindOrganizationUsersQueryResponse>,
  TQueryData = ResponseConfig<FindOrganizationUsersQueryResponse>,
  TQueryKey extends QueryKey = FindOrganizationUsersQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindOrganizationUsersQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findOrganizationUsersQueryKey()

  const query = useQuery(
    {
      ...findOrganizationUsersQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
